export default "__VITE_ASSET__BlmbTXWz__"